import React, {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../../stores";
import {Grid} from "@mui/material";
import {QuarterDateRangePickerMui} from "../../../../components/date-range-picker/QuarterDateRangePickerMui.tsx";
import {SearchComponent} from "../../../../components/SearchComponet";
import {PpvFilterModal} from "../modals/PpvFilterModal";
import {
    ApiDropdownFilterComponent
} from "../../../../components/visualization/api-dropdown-filter/ApiDropdownFilterComponent";
import {getPpvFilterOptions} from "../classes/PpvConfig";
import dayjs from "dayjs";

export const PpvFilterBarComponent: React.FC = observer(() => {
    const {p, ppvControllerStore, materializedApi} = useStores();
    const filterController = ppvControllerStore.ppvPageController.ppvPageFilterController;
    const filter = filterController.activeFilter;

    const enabledFilters = getPpvFilterOptions(p);

    // The default values are memoize to avoid re-rendering the dropdowns
    // This way we can set the default when navigating to the page, and at the same time use the changes to update the filters
    // This is using a MUI-uncontrolled architecture: see https://mui.com/material-ui/react-text-field/#uncontrolled-vs-controlled
    const {pNameDefault, sNameDefault, ccDefault, buDefault} = useMemo(() => ({
        pNameDefault: filterController.pNameFilter,
        sNameDefault: filterController.supplierFilter,
        ccDefault: filterController.ccDescriptionFilter,
        buDefault: filterController.businessUnitFilter,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [])

    // Skip rendering, to reduce useless API calls
    if (filter.databag === -1) return <></>

    // Note: A reset button might be usefull, but difficult to add with this architecture.
    // We need to switch to a controlled state for these dropdowns and filters.

    return (
        <>
            {/*<p>filter = {JSON.stringify(filter)}</p>*/}
            <PpvFilterModal/>

            <Grid container alignItems="center">
                <Grid style={{flexBasis: '16em'}}>
                    <QuarterDateRangePickerMui
                        value={[dayjs(filterController.startDate), dayjs(filterController.endDate)]}
                        onChange={(value) => {
                            const startDate = value[0]?.format('YYYY-MM-DD') || '';
                            const endDate = value[1]?.format('YYYY-MM-DD') || '';
                            filterController.dateFilterChanged(startDate, endDate)
                        }}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 3,
                        lg: 3
                    }}>
                    <SearchComponent
                        // Controlled component
                        className="ppv-search-component"
                        searchFieldLabel="Search by description"
                        sm={filterController.ppvSearchManager}
                        componentId="ppv-search"
                        fullWidth
                    />
                </Grid>
                <Grid style={{marginLeft: 'auto'}}>
                    {enabledFilters.includes('part') && <ApiDropdownFilterComponent
                    // Uncontrolled component
                        label={p.partDataName}
                        getOptions={search => materializedApi.listPpvSearchPName(search, filter)
                            .then(resp => ({
                                ...resp.data,
                                results: resp.data.results.map(obj => ({id: obj.p_name, label: obj.p_name, obj}))
                            }))
                        }
                        defaultSelection={pNameDefault}
                    onSelectionChange={selection => filterController.setPNameFilter(selection)}
                    buttonProps={{sx: {m: '0.5em'}}}
                    />}
                {enabledFilters.includes('supplier') && <ApiDropdownFilterComponent
                        // Uncontrolled component
                        label={p.supplierDataName}
                    getOptions={search => materializedApi.listPpvSearchSuppliers(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({id: obj.id, label: obj.s_name, obj}))
                        }))
                    }
                    defaultSelection={sNameDefault}
                    onSelectionChange={selection => filterController.setSupplierFilter(selection)}
                    buttonProps={{sx: {m: '0.5em'}}}
                    />}
                    {enabledFilters.includes('cc_description') && <ApiDropdownFilterComponent
                        // Uncontrolled component
                        label={p.ccDescriptionDataName}
                    getOptions={search => materializedApi.listPpvSearchCCDescription(search, filter)
                        .then(resp => ({
                            ...resp.data,
                            results: resp.data.results.map(obj => ({
                                id: obj.cc_description,
                                label: obj.cc_description,
                                obj
                            }))
                        }))
                    }
                    defaultSelection={ccDefault}
                    onSelectionChange={selection => filterController.setCcDescriptionFilter(selection)}
                    buttonProps={{sx: {m: '0.5em'}}}
                    />}
                    {enabledFilters.includes('business_unit') && <ApiDropdownFilterComponent
                    // Uncontrolled component
                        label={p.buDataName}
                        getOptions={search => materializedApi.listPpvSearchBusinessUnits(search, filter)
                            .then(resp => ({
                                ...resp.data,
                                results: resp.data.results.map(obj => ({id: obj.id, label: obj.bu_name, obj}))
                            }))
                        }
                        defaultSelection={buDefault}
                    onSelectionChange={selection => filterController.setBusinessUnitFilter(selection)}
                    buttonProps={{sx: {m: '0.5em'}}}
                    />}
                </Grid>
                {/*<Grid style={{marginLeft: 'auto'}}>*/}
                {/*    <Button*/}
                {/*        endIcon={<FilterAlt/>}*/}
                {/*        variant='outlined'*/}
                {/*        onClick={() => {*/}
                {/*            filterController.setFilterDialogOpen(true)*/}
                {/*        }}>*/}
                {/*        Filter*/}
                {/*    </Button>*/}
                {/*</Grid>*/}
            </Grid>
        </>
    );
})